import { makeActionCreator } from '../../../utilities'
import { FactorsAffectingCareConstants } from './factorsAffectingCare.constants'

export const setDispatchFactors = makeActionCreator(
  FactorsAffectingCareConstants.SET_DISPATCH_FACTORS,
  'dispatchFactors'
)
export const setDispatchFactorsPNNV = makeActionCreator(
  FactorsAffectingCareConstants.SET_DISPATCH_FACTORS_PNNV,
  'dispatchFactorsPNNV'
)
export const setResponseFactors = makeActionCreator(
  FactorsAffectingCareConstants.SET_RESPONSE_FACTORS,
  'responseFactors'
)
export const setResponseFactorsPNNV = makeActionCreator(
  FactorsAffectingCareConstants.SET_RESPONSE_FACTORS_PNNV,
  'responseFactorsPNNV'
)
export const setSceneFactors = makeActionCreator(FactorsAffectingCareConstants.SET_SCENE_FACTORS, 'sceneFactors')
export const setSceneFactorsPNNV = makeActionCreator(
  FactorsAffectingCareConstants.SET_SCENE_FACTORS_PNNV,
  'sceneFactorsPNNV'
)
export const setTransportFactors = makeActionCreator(
  FactorsAffectingCareConstants.SET_TRANSPORT_FACTORS,
  'transportFactors'
)
export const setTransportFactorsPNNV = makeActionCreator(
  FactorsAffectingCareConstants.SET_TRANSPORT_FACTORS_PNNV,
  'transportFactorsPNNV'
)
export const setTurnAroundFactors = makeActionCreator(
  FactorsAffectingCareConstants.SET_TURN_AROUND_FACTORS,
  'turnAroundFactors'
)
export const setTurnAroundFactorsPNNV = makeActionCreator(
  FactorsAffectingCareConstants.SET_TURN_AROUND_FACTORS_PNNV,
  'turnAroundFactorsPNNV'
)
export const setFactors = makeActionCreator(FactorsAffectingCareConstants.SET_FACTORS, 'factors')
export const setShowFactors = makeActionCreator(FactorsAffectingCareConstants.SET_SHOW_FACTORS, 'showFactors')
export const setShowDispatchFactors = makeActionCreator(
  FactorsAffectingCareConstants.SET_SHOW_DISPATCH_FACTORS,
  'showDispatchFactors'
)
export const setShowTurnAroundFactors = makeActionCreator(
  FactorsAffectingCareConstants.SET_SHOW_TURN_AROUND_FACTORS,
  'showTurnAroundFactors'
)
export const setShowResponseSceneTransportFactors = makeActionCreator(
  FactorsAffectingCareConstants.SET_SHOW_RESPONSE_SCENE_TRANSPORT_FACTORS,
  'showResponseSceneTransportFactors'
)
export const setFactorsAffectingCareState = makeActionCreator(
  FactorsAffectingCareConstants.SET_FACTORS_AFFECTING_CARE_STATE,
  'factorsAffectingCare'
)
export const getFactorsAffectingCareState = makeActionCreator(
  FactorsAffectingCareConstants.GET_FACTORS_AFFECTING_CARE_STATE
)
export const saveFactorsAffectingCare = makeActionCreator(
  FactorsAffectingCareConstants.SAVE_FACTORS_AFFECTING_CARE_STATE
)
export const resetFactorsAffectingCareState = makeActionCreator(
  FactorsAffectingCareConstants.RESET_FACTORS_AFFECTING_CARE_STATE
)
